
import { Component, Vue } from 'nuxt-property-decorator'
import { Swiper, SwiperSlide } from 'swiper-vue2'
import BlackFridayBlogCard from '~/components/black-friday/BlackFridayBlogCard.vue'

type BlogCards = Readonly<
  {
    image: string,
    header: string,
    text: string,
    url: string,
  }[]
>

@Component({
  components: {
    BlackFridayBlogCard,
    Swiper,
    SwiperSlide,
  },
})
export default class BlackFridayBlogCards extends Vue {
  readonly TOTAL_SLIDES: number = 3
  get cards (): BlogCards {
    const data = [
      {
        image: require('~/assets/images/black-friday/blog-tips.png'),
        header: this.$t('blackFriday.blogs.2.title') as string,
        text: this.$t('blackFriday.blogs.2.text') as string,
        slug: {
          en: 'black-friday-tips',
          de: 'black-friday-tipps',
          fr: 'black-friday-conseils',
        },
      },
      {
        image: require('~/assets/images/black-friday/blog-fact-2.webp'),
        header: this.$t('blackFriday.blogs.1.title') as string,
        text: this.$t('blackFriday.blogs.1.text') as string,
        slug: {
          en: 'black-friday-facts',
          de: 'black-friday-fakten',
          fr: 'black-friday-faits',
        },
      },
      {
        image: require('~/assets/images/black-friday/blog-yallo.webp'),
        header: this.$t('blackFriday.blogs.3.title') as string,
        text: this.$t('blackFriday.blogs.3.text') as string,
        slug: {
          en: 'yallo-black',
          de: 'yallo-black',
          fr: 'yallo-black',
        },
      },
    ]

    return data.map(item => ({
      ...item,
      url: `/${this.$i18n.locale}/blogs/${item.slug[this.$i18n.locale as 'en' | 'de' | 'fr']}`,
    }))
  }

  get calculatedSlides () {
    if (this.$mqUtils.isXS) {
      return 1.1
    }
    if (this.$mqUtils.isMD || this.$mqUtils.isSM) {
      return 2.1
    }

    return this.TOTAL_SLIDES
  }
}
